/*
 *
 * FurnitureInfos
 *
 */

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { RootState } from 'containers/PanesPanel/types';
import { Cabinet } from 'lib/modelBuilder/entities/Cabinet';
import {
  makeSelectCabinet,
  makeSelectFurniture,
  makeSelectSelectedIdCabinet,
} from 'containers/Configurator/selectors/furniture';
import { Furniture } from 'lib/modelBuilder/entities/Furniture';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components/macro';
import useMedia from 'use-media';
import { displayDimensionAction } from '../Configurator/actions/general';
import { RiRuler2Line } from 'react-icons/all';
import { makeSelectDisplaySchemaDimension } from '../Configurator/selectors/general';
import SeeSchemaDimensionBtn from './SeeSchemaDimensionBtn';

interface StateProps {
  cabinet: Cabinet | null;
  furniture: Furniture | null;
  selectedCabinetId: string | null;
  displayDimension: boolean;
}

const stateSelector = createStructuredSelector<RootState, StateProps>({
  cabinet: makeSelectCabinet(),
  furniture: makeSelectFurniture(),
  selectedCabinetId: makeSelectSelectedIdCabinet(),
  displayDimension: makeSelectDisplaySchemaDimension(),
});

function DimensionInfos() {
  const { cabinet, furniture, selectedCabinetId } = useSelector(stateSelector);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isMobile = useMedia({ maxWidth: 1023 });

  const { displayDimension } = useSelector(stateSelector);

  if (selectedCabinetId === null && furniture) {
    return (
      <div className="flex justify-start">
        <DimensionWrapperStyled>
          <button
            className="flex"
            onClick={() => {
              dispatch(displayDimensionAction(!displayDimension));
            }}
          >
            <DimensionValueStyled>
              <DimensionStyled>
                <span>
                  {isMobile ? t('short.height') : t('Height')}&nbsp;&nbsp;
                </span>
                <span className="font-semibold">
                  {furniture.height / 10}&nbsp;cm
                </span>
              </DimensionStyled>
              <DimensionStyled>
                <span>
                  {isMobile ? t('short.width') : t('Width')}&nbsp;&nbsp;
                </span>
                <span className="font-semibold">
                  {furniture.width / 10}&nbsp;cm
                </span>
              </DimensionStyled>
              <DimensionStyled>
                <span>
                  {isMobile ? t('short.depth') : t('Depth')}&nbsp;&nbsp;
                </span>
                <span className="font-semibold">
                  {furniture.depth / 10}&nbsp;cm
                </span>
              </DimensionStyled>
            </DimensionValueStyled>
            {!isMobile && <SeeSchemaDimensionBtn />}
          </button>
        </DimensionWrapperStyled>
      </div>
    );
  }
  if (cabinet) {
    return (
      <div className="flex w-full justify-start">
        <DimensionWrapperStyled>
          <button
            className="flex"
            onClick={() => {
              if (!displayDimension) dispatch(displayDimensionAction(true));
              else dispatch(displayDimensionAction(false));
            }}
          >
            <DimensionValueStyled>
              <DimensionStyled>
                <span>
                  {isMobile ? t('short.height') : t('Height')}&nbsp;&nbsp;
                </span>
                <span className="font-semibold">
                  {cabinet.height / 10}&nbsp;cm
                </span>
              </DimensionStyled>
              <DimensionStyled>
                <span>
                  {isMobile ? t('short.width') : t('Width')}&nbsp;&nbsp;
                </span>
                <span className="font-semibold">
                  {cabinet.width / 10}&nbsp;cm
                </span>
              </DimensionStyled>
              <DimensionStyled>
                <span>
                  {isMobile ? t('short.depth') : t('Depth')}&nbsp;&nbsp;
                </span>
                <span className="font-semibold">
                  {cabinet.depth / 10}&nbsp;cm
                </span>
              </DimensionStyled>
            </DimensionValueStyled>
            {!isMobile && <SeeSchemaDimensionBtn />}
          </button>
        </DimensionWrapperStyled>
      </div>
    );
  }
  return null;
}

export default DimensionInfos;

const DimensionWrapperStyled = styled.div`
  margin-top: 1rem;
  background-color: #fff;
  border-width: 1px;
  border-color: ${p => p.theme.gray300};
  padding: 0;
`;

const DimensionValueStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: space-around;
  padding: 0.25rem;
`;

const DimensionStyled = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  font-size: 0.75rem;
  margin: 0;
  padding: 0;
  line-height: 1.25;
  color: ${p => p.theme.gray600};
`;
